export enum DischargeType {
	"ALTA MELHORADA" = 1,
	"ALTA CURADA" = 2,
	"ALTA A PEDIDO" = 3,
	"ALTA POR ÓBITO" = 5,
	"ALTA POR TRANSFERÊNCIA" = 7,
	"ALTA POR INDICAÇÃO MÉDICA" = 8,
}
